var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7206 9.7206C10.1304 9.31083 10.4554 8.82437 10.6772 8.28899C10.8989 7.7536 11.0131 7.17978 11.0131 6.60029C11.0131 6.02079 10.8989 5.44697 10.6772 4.91159C10.4554 4.3762 10.1304 3.88974 9.7206 3.47998C9.31084 3.07021 8.82437 2.74517 8.28899 2.5234C7.7536 2.30164 7.17978 2.1875 6.60029 2.1875C6.02079 2.1875 5.44697 2.30164 4.91159 2.5234C4.3762 2.74517 3.88974 3.07021 3.47998 3.47998C2.65242 4.30753 2.1875 5.42994 2.1875 6.60029C2.1875 7.77063 2.65242 8.89304 3.47998 9.7206C4.30753 10.5482 5.42994 11.0131 6.60029 11.0131C7.77063 11.0131 8.89304 10.5482 9.7206 9.7206ZM9.7206 9.7206L12.5 12.5",
    stroke: "white",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchWhite);
export default __webpack_public_path__ + "static/media/searchWhite.eabfdf3383ca2f8f06b4c6b12c0616be.svg";
export { ForwardRef as ReactComponent };